import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const DevelopersOverviewAdminComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "DevelopersOverviewAdminApp" */ "@circle-react/components/SettingsApp/DevelopersOverview"
    ),
);

export const DevelopersOverviewPage = () => (
  <Suspense fallback={<PageLoader />}>
    <DevelopersOverviewAdminComponent />
  </Suspense>
);
